var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgVerifiedPerson(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_1189_3246)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M6.66406 5.83333C6.66406 6.71739 7.01525 7.56524 7.64037 8.19036C8.26549 8.81548 9.11334 9.16667 9.9974 9.16667C10.8815 9.16667 11.7293 8.81548 12.3544 8.19036C12.9795 7.56524 13.3307 6.71739 13.3307 5.83333C13.3307 4.94928 12.9795 4.10143 12.3544 3.47631C11.7293 2.85119 10.8815 2.5 9.9974 2.5C9.11334 2.5 8.26549 2.85119 7.64037 3.47631C7.01525 4.10143 6.66406 4.94928 6.66406 5.83333Z",
    stroke: "#262626",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M5 17.5V15.8333C5 14.9493 5.35119 14.1014 5.97631 13.4763C6.60143 12.8512 7.44928 12.5 8.33333 12.5H11.6667",
    stroke: "#262626",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M12.5 15.8333L14.1667 17.5L17.5 14.1666",
    stroke: "#262626",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_1189_3246"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 20,
    height: 20,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgVerifiedPerson);
export default __webpack_public_path__ + "static/media/verifiedPerson.cb9a51c6ebe4329bf1e9cbc85d41f8a7.svg";
export { ForwardRef as ReactComponent };